// Basic Accessibility Enhancements for Shopify Store
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const iframe = document.getElementById("PBarNextFrame");
    
    if (iframe) {
      iframe.setAttribute("title", "Progress Bar Content"); 
    }
  }, 5000);
});

// Collection Page Accessibility
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a.full-unstyled-link").forEach((link) => {
    const href = link.getAttribute("href");
    const text = link.textContent.trim();

    if (!href || href === "#" || text.length === 0) {
      // Make link non-accessible
      link.setAttribute("role", "presentation");
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-hidden", "true");

      // Remove unnecessary attributes
      link.removeAttribute("id");
      link.removeAttribute("aria-labelledby");
    }
  });
});

// Accessible Tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-button[role='tab']");

  tabs.forEach((tab, index) => {
    // Add ID to tab if missing
    if (!tab.id) {
      tab.id = "tab-button-" + index;
    }

    const panelId = tab.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);

    // Connect panel with tab button correctly
    if (panel) {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", tab.id);

      // Fix initial state
      if (tab.getAttribute("aria-selected") === "true") {
        panel.removeAttribute("hidden");
        panel.setAttribute("aria-hidden", "false");
      } else {
        panel.setAttribute("hidden", "");
        panel.setAttribute("aria-hidden", "true");
      }
    }

    tab.addEventListener("click", function () {
      activateTab(this, true);
    });

    tab.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activateTab(this, true);
      }

      // Optional arrow key support
      if (
        e.key === "ArrowRight" ||
        e.key === "ArrowLeft" ||
        e.key === "Home" ||
        e.key === "End"
      ) {
        e.preventDefault();

        const tabList = this.closest("[role='tablist']");
        const allTabs = Array.from(tabList.querySelectorAll("[role='tab']"));
        const currentIndex = allTabs.indexOf(this);
        let newIndex = currentIndex;

        if (e.key === "ArrowRight") {
          newIndex = currentIndex + 1 >= allTabs.length ? 0 : currentIndex + 1;
        }

        if (e.key === "ArrowLeft") {
          newIndex = currentIndex - 1 < 0 ? allTabs.length - 1 : currentIndex - 1;
        }

        if (e.key === "Home") {
          newIndex = 0;
        }

        if (e.key === "End") {
          newIndex = allTabs.length - 1;
        }

        activateTab(allTabs[newIndex], false);
        allTabs[newIndex].focus();
      }
    });
  });

  function activateTab(activeTab, focusPanel) {
    const tabList = activeTab.closest("[role='tablist']");
    const allTabs = tabList.querySelectorAll("[role='tab']");

    allTabs.forEach((tab) => {
      tab.classList.remove("active");
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");

      const panelId = tab.getAttribute("aria-controls");
      const panel = document.getElementById(panelId);

      if (panel) {
        panel.classList.remove("active");
        panel.setAttribute("hidden", "");
        panel.setAttribute("aria-hidden", "true");
      }
    });

    activeTab.classList.add("active");
    activeTab.setAttribute("aria-selected", "true");
    activeTab.setAttribute("tabindex", "0");

    const activePanelId = activeTab.getAttribute("aria-controls");
    const activePanel = document.getElementById(activePanelId);

    if (activePanel) {
      activePanel.classList.add("active");
      activePanel.removeAttribute("hidden");
      activePanel.setAttribute("aria-hidden", "false");

      // This helps screen reader announce the newly opened panel content
      if (focusPanel) {
        setTimeout(function () {
          activePanel.setAttribute("tabindex", "-1");
          activePanel.focus();
        }, 150);
      }
    }
  }
});

// Size chart modal accessibility
document.addEventListener("DOMContentLoaded", function () {
  const sizeChart = document.querySelector("size-chart");

  if (!sizeChart) return;

  const tabs = Array.from(
    sizeChart.querySelectorAll(".size-chart-tab-title-button[role='tab']")
  );

  const panels = Array.from(
    sizeChart.querySelectorAll(".size-chart-content-container[role='tabpanel']")
  );

  if (!tabs.length || !panels.length) return;

  // Setup correct ARIA connection
  tabs.forEach(function (tab, index) {
    const tabId = tab.id || "size-chart-tab-" + (index + 1);
    const panelId = panels[index].id || "size-chart-panel-" + (index + 1);

    tab.id = tabId;
    tab.setAttribute("role", "tab");
    tab.setAttribute("aria-controls", panelId);

    panels[index].id = panelId;
    panels[index].setAttribute("role", "tabpanel");
    panels[index].setAttribute("aria-labelledby", tabId);
  });

  function activateTab(selectedTab, moveFocusToPanel) {
    const selectedIndex = tabs.indexOf(selectedTab);

    tabs.forEach(function (tab, index) {
      const isSelected = index === selectedIndex;

      tab.classList.toggle("active", isSelected);
      tab.setAttribute("aria-selected", isSelected ? "true" : "false");
      tab.setAttribute("tabindex", isSelected ? "0" : "-1");

      panels[index].classList.toggle("visible", isSelected);
      panels[index].setAttribute("aria-hidden", isSelected ? "false" : "true");

      if (isSelected) {
        panels[index].removeAttribute("hidden");
      } else {
        panels[index].setAttribute("hidden", "");
      }
    });

    if (moveFocusToPanel && panels[selectedIndex]) {
      setTimeout(function () {
        panels[selectedIndex].setAttribute("tabindex", "-1");
        panels[selectedIndex].focus();
      }, 150);
    }
  }

  // Fix initial selected tab based on active class
  const activeTab =
    tabs.find(function (tab) {
      return tab.classList.contains("active");
    }) || tabs[0];

  activateTab(activeTab, false);

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      activateTab(tab, true);
    });

    tab.addEventListener("keydown", function (event) {
      const currentIndex = tabs.indexOf(tab);
      let nextIndex = null;

      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        activateTab(tab, true);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        nextIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        nextIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
      }

      if (event.key === "Home") {
        event.preventDefault();
        nextIndex = 0;
      }

      if (event.key === "End") {
        event.preventDefault();
        nextIndex = tabs.length - 1;
      }

      if (nextIndex !== null) {
        activateTab(tabs[nextIndex], false);
        tabs[nextIndex].focus();
      }
    });
  });
});

// External Link Accessibility
document.addEventListener("DOMContentLoaded", () => {
  const externalWarning =
    "Redirecting to a third-party website (opens in a new tab)";

  const excludedLinks = [
    "https://www.facebook.com/",
    "https://www.bcorporation.net/en-us/find-a-b-corp/company/saalt-llc/",
    "https://www.instagram.com/saaltco/",
    "https://www.facebook.com/saaltco/",
    "https://www.youtube.com/@saaltco/",
    "https://www.tiktok.com/@saaltco/",
    "https://www.pinterest.com/saaltco/",
    "https://www.threads.net/@saaltco/",
    "https://www.linkedin.com/company/saaltco/"
  ];

  const isThirdParty = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin);
      return linkUrl.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  };

  const isExcluded = (href) => {
    return excludedLinks.some((excluded) => href.startsWith(excluded));
  };

  const handleExternalLinks = () => {
    document.querySelectorAll("a[href]").forEach((link) => {
      const href = link.getAttribute("href");

      if (
        !href ||
        href.startsWith("#") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        !isThirdParty(href) ||
        isExcluded(href)
      ) {
        return;
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      // Ignore adding aria-label if already present
      if (!link.hasAttribute("aria-label")) {
        const existingLabel = link.textContent.trim();

        if (existingLabel) {
          link.setAttribute("aria-label", `${existingLabel}, ${externalWarning}`);
        } else {
          link.setAttribute("aria-label", externalWarning);
        }
      }

      const img = link.querySelector("img");

      if (img) {
        const altText = img.getAttribute("alt") || "";

        img.setAttribute(
          "alt",
          altText ? `${altText}, ${externalWarning}` : externalWarning
        );
      }

      const svg = link.querySelector("svg");

      if (svg) {
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
      }
    });
  };

  const handleContactLinks = () => {
    document
      .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
      .forEach((link) => {
        const href = link.getAttribute("href");
        const linkText = link.textContent.trim();

        // Ignore adding aria-label if already present
        if (link.hasAttribute("aria-label")) {
          return;
        }

        if (href.startsWith("mailto:")) {
          link.setAttribute("aria-label", `Email Address: ${linkText}`);
        }

        if (href.startsWith("tel:")) {
          link.setAttribute("aria-label", `Phone number: ${linkText}`);
        }
      });
  };

  handleExternalLinks();
  handleContactLinks();
});
document.addEventListener("DOMContentLoaded", function () {
  const externalWarning =
    "Redirecting to a third-party website (opens in a new tab)";

  const socialLinks = {
    "https://www.instagram.com/saaltco/": "Visit Saalt on Instagram",
    "https://www.facebook.com/saaltco/": "Visit Saalt on Facebook",
    "https://www.youtube.com/@saaltco/": "Visit Saalt on YouTube",
    "https://www.tiktok.com/@saaltco/": "Visit Saalt on TikTok",
    "https://www.pinterest.com/saaltco/": "Visit Saalt on Pinterest",
    "https://www.threads.net/@saaltco/": "Visit Saalt on Threads",
    "https://www.linkedin.com/company/saaltco": "Visit Saalt on LinkedIn"
  };

  Object.keys(socialLinks).forEach(function (url) {
    const links = document.querySelectorAll(`a[href="${url}"]`);

    links.forEach(function (link) {
      link.setAttribute("target", "_blank");
      link.removeAttribute("title");
      link.setAttribute(
        "aria-label",
        `${socialLinks[url]}, ${externalWarning}`
      );

      const svg = link.querySelector("svg");

      if (svg) {
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const facebookLinks = document.querySelectorAll(
    'a[href="https://www.facebook.com/groups/saaltcupacademy/"]'
  );

  facebookLinks.forEach(function (link) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    link.setAttribute(
      "aria-label",
      "Join Saalt Cup Academy, Redirecting to a third-party website (opens in a new tab)"
    );
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const bCorpLink = document.querySelector(
    'a[href="https://www.bcorporation.net/en-us/find-a-b-corp/company/saalt-llc/"]'
  );

  if (bCorpLink) {
    bCorpLink.setAttribute(
      "aria-label",
      "Certified B Corporation logo, Redirecting to a third-party website (opens in a new tab)"
    );
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const facebookLinks = document.querySelectorAll(
    'a[href="https://www.facebook.com/groups/saaltcupacademy/?ref=bookmarks"]'
  );

  facebookLinks.forEach(function (link) {
    link.setAttribute(
      "aria-label",
      "Saalt Cup Academy, Redirecting to a third-party website (opens in a new tab)"
    );
  });
});

// Removing aria-describedby
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a.full-unstyled-link").forEach(function (link) {
    link.removeAttribute("id");
    link.removeAttribute("aria-labelledby");
  });
});

// Collection Cards - Adding alt text to product images
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.querySelectorAll(".card-wrapper.product-card-wrapper").forEach(function (card) {
      const titleEl = card.querySelector(".card__content .card__heading a.full-unstyled-link:not([aria-hidden='true'])");
      const firstImg = card.querySelector(".media.media--transparent.media--hover-effect img:first-of-type");

      if (!titleEl || !firstImg) return;

      const titleText = titleEl.textContent.replace(/\s+/g, " ").trim();

      if (titleText) {
        firstImg.setAttribute("alt", titleText);
      }
    });
  }, 2000);
});

// Js For MenU On NVDA And JAWS Screen Readers - Making summary elements accessible
document.addEventListener('DOMContentLoaded', function () {
  const summaries = document.querySelectorAll('details.mega-menu > summary');

  summaries.forEach(function (summary) {
    const details = summary.closest('details');

    if (!details) return;

    // Make summary behave like a proper button for screen readers
    summary.setAttribute('role', 'button');
    summary.setAttribute('tabindex', '0');
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    // Remove keyboard focus from link inside summary
    const innerLinks = summary.querySelectorAll('a');

    innerLinks.forEach(function (link) {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });

    // Keyboard support: Enter / Space toggle menu
    summary.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();

        details.open = !details.open;

        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }

      // Escape closes menu
      if (event.key === 'Escape') {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
    });

    // Mouse click should still allow normal summary toggle
    summary.addEventListener('click', function () {
      setTimeout(function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }, 0);
    });

    // Keep aria-expanded updated if details changes
    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  });
});

// Adding Labels to "Learn More" Links
document.addEventListener("DOMContentLoaded", function () {
  const learnMoreLinks = document.querySelectorAll('a.button[href="/pages/impact"]');

  learnMoreLinks.forEach(function (link) {
    const section = link.closest(".text-wrapper");
    const heading = section ? section.querySelector(".section-title") : null;

    const linkText = link.textContent.trim();
    const headingText = heading ? heading.textContent.trim() : "";

    if (linkText && headingText) {
      link.setAttribute("aria-label", linkText + ", " + headingText);
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".text-wrapper");

  wrappers.forEach(function (wrapper) {
    const heading = wrapper.querySelector(".section-title");
    const buttons = wrapper.querySelectorAll(".button-group a.button");

    if (!heading || !buttons.length) return;

    const headingText = heading.textContent.trim();

    buttons.forEach(function (button) {
      const buttonText = button.textContent.trim();

      if (buttonText && headingText) {
        button.setAttribute("aria-label", buttonText + ", " + headingText);
      }
    });
  });
});